import NavBar from "./components/NavBar/NavBar"
import "./App.css"
import Banner from "./components/Banner/Banner"
import PostsRow from "./components/PostsRow/PostsRow"
import { actionUrl,advUrl, comUrl } from "./components/Constants/Content"

function App() {
  return (
    <div>
      <NavBar/>
      <Banner/>
      
      <PostsRow url={actionUrl} title="Action" />
      <PostsRow url={advUrl} title="Adventure"/>
      <PostsRow url={comUrl} title="Comedy"/>

    </div>
  )
}

export default App

